export default "__VITE_ASSET__HGaAMAHLy$_BD_h4Jc_LCw__"